<script setup>
import { ref, computed } from "vue";
import Select from "primevue/select";
import Button from "primevue/button";
import Avatar from "primevue/avatar";
import { router } from "@inertiajs/vue3";

const props = defineProps({
    slim: Boolean,
    skipWorkers: {
        default: [],
        type: Array
    },
    workers: Array,
    reloadable: {
        default: ['workers'],
        type: Array
    }
})

const emit = defineEmits(['select'])

const selectedOption = ref(null);
const filterValue = ref('');
const addLoading = ref(false);

const availableWorkers = computed(() =>
    props.workers?.filter(w => !props.skipWorkers.includes(w.id)) ?? []
)

const onSelect = () => {
    if (!selectedOption.value) return;
    emit('select', selectedOption.value);
    selectedOption.value = null;
}

const addWorker = () => {
    addLoading.value = true;
    router.visit('/app/forms/add-worker', {
        method: 'post',
        data: { name: filterValue.value },
        only: props.reloadable,
        preserveScroll: true,
        preserveState: true,
        onFinish: () => {
            addLoading.value = false;
        }
    })
}
</script>

<template>
    <Select
        v-model="selectedOption"
        :options="availableWorkers"
        optionLabel="name"
        filter
        :filterPlaceholder="$t('forms.workers_search_placeholder')"
        :placeholder="$t('forms.workers_add_colleague')"
        fluid
        @change="onSelect"
        @filter="filterValue = $event.value"
        resetFilterOnHide
    >
        <template #option="{ option }">
            <div class="flex items-center gap-2">
                <Avatar :label="option.initials" />
                <span>{{ option.name }}</span>
            </div>
        </template>

        <template #footer>
            <div class="px-3 py-2 border-t dark:border-neutral-700" v-if="filterValue.trim()">
                <Button
                    :label="$t('forms.workers_add_colleague_label', { name: filterValue })"
                    :loading="addLoading"
                    @click="addWorker"
                    severity="secondary"
                    text
                    size="small"
                    icon="pi pi-plus"
                />
            </div>
        </template>
    </Select>
</template>
